/**
 * Replaces [offerTitle] shortcodes with the offer title
 *
 * @param props - Function parameters
 * @param props.context - Shortcode context containing text
 * @param props.offerTitle - Title of an offer ex: 'Plan Paie'
 *
 * @returns Updated text with replaced shortcodes
 *
 * @example
 * ```ts
 * applyOfferTitle({
 *   context: { text: "[offerTitle]", locale: "en" },
 *   offerTitle: 'Plan Paie'
 * });
 * // Result: 'Plan Paie'
 * ```
 */
import { ShortcodeContext } from '..';

export const applyOfferTitle = ({
  context,
  offerTitle,
}: {
  context: ShortcodeContext;
  offerTitle: string;
}): string => {
  // Special case for 'Starter Offer':
  // - Keep original title without 'Plan' prefix for Starter offers
  // - Add 'Plan' prefix for all other offers to maintain consistent naming
  const starterOfferTitles = ['offre starter', 'starter offer'];

  const _offerTitle = starterOfferTitles.includes(offerTitle.toLowerCase()) 
    ? offerTitle 
    : `Plan ${offerTitle}`;

  context.text = context.text.replace(
    /\[offerTitle\]/g,
    `${_offerTitle}`,
  );
  return context.text;
};
